var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st1{fill:#fff}\n    ")), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.9,
    style: {
      fill: "#4ba543"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15 .3C23.1.3 29.7 6.9 29.7 15S23.1 29.7 15 29.7.3 23.1.3 15 6.9.3 15 .3m0-.3C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 24.2 2.2 15.4c-.3-.2-.3-.5 0-.8l12.3-8.8c.3-.2.7-.2 1.1 0l12.3 8.8c.3.2.3.5 0 .8l-12.3 8.8c-.4.2-.8.2-1.1 0z",
    style: {
      fill: "#fece3f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5.3,
    style: {
      fill: "#2387eb"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.8 11.7c-1-.2-1.9-.3-2.7-.3-.4.4-.8 1-1 1.5 2.3-.1 7.3.3 9.7 4.3.3-.6.5-1.3.5-2-1.5-1.7-3.7-3-6.5-3.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 9.8c1.6.9 2.7 2.6 2.7 4.6 0 2.9-2.4 5.3-5.3 5.3-.3 0-.6 0-.9-.1.8.4 1.6.7 2.6.7 2.9 0 5.3-2.4 5.3-5.3 0-2.6-1.9-4.8-4.4-5.2z",
    style: {
      opacity: 0.1,
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 2.7S11 7.3 19.1 9s8.2 8.9 8.2 8.9c0-.3.2-.8.3-1.1.2-.8.4-1.8.4-2.7.1-2.9-.9-5.7-2.7-7.9-1.6-1.9-3.7-3.4-6.1-3.9-3.1-.7-6.3-.5-9.3.4z",
    style: {
      opacity: 0.2,
      fill: "#fff",
      enableBackground: "new"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtBr);
export default __webpack_public_path__ + "static/media/pt_br.a10ad689aff3cf035814264ab52a6555.svg";
export { ForwardRef as ReactComponent };